<template>
  <div class="box">
    <div v-on:paste="handlePaste">
      <img v-if='lockImg' ref="preview" :src="imgUrl+lockImg" alt="" style="width:400px;height:300px;">
      <div v-else style="width:300px;height:300px;border:1px solid;padding:20px;">
        <div style="text-indent:2em;">将图片按<span style="color:red">cmd+C复制</span>到粘贴板，<span style="color:red">cmd+V粘贴</span>至此处；</div>
        <div style="text-indent:2em;">或者<span style="color:red">Ctrl+Shift+cmd+4截图</span>保存在粘贴板，<span style="color:red">cmd+V粘贴</span>至此处</div>
      </div>
    </div>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import api from '@/api'

export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      lockImg: ''
    }
  },
  props: {
    img: {
      type: String,
      default: ''
    }
  },
  watch: {
    img: function(val) {
      this.lockImg = val
    }
  },
  mounted() {
    if (this.img) {
      this.lockImg = this.img
    } else {
      this.lockImg = ''
    }
  },
  methods: {
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      // 此时file就是我们的剪切板中的图片对象   
      this.file = file
      this.uploadPlans()
    },
    // 上传文件成功后回调
    uploadPlans() {
      const file = this.file
      if (!file) {
        this.$message.error('请粘贴图片后上传')
        return
      }
      this.loading = true
      const form = new FormData()
      form.append('upload', file)
      form.append('type', this.type)
     api.uploadImg(form).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '上传成功!'
          })
          this.lockImg = res.data.coverImg
          this.changeImgUrl()
        } else {
          this.$message({
            type: 'error',
            message: '上传失败!'
          })
          this.lockImg = ''
        }
      })
    },

    changeImgUrl() {
      this.$emit('changeImgUrl', this.lockImg)
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
</style>
